module.exports = __webpack_public_path__ + "assets/search-icon-mobile-b5f570.svg";